import { GetListParams } from 'react-admin';
import { CustomDataProvider, registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { listHotWallets } from '../../../services/xbitRelayService';

const resourceName = 'xbit-relay/hot-wallets';

export const xbitRelayHotWalletsDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const provider = (params.filter?.provider as string | undefined) || undefined;
    const response = await listHotWallets(provider);
    const wallets = response.data?.wallets ?? [];
    const rows = wallets.flatMap((wallet) =>
      (wallet.balances ?? []).map((balance, index) => ({
        id: `${wallet.chainId}-${wallet.address}-${balance.tokenAddress}-${index}`,
        chainId: wallet.chainId,
        chainName: wallet.chainName,
        chainType: wallet.chainType,
        address: wallet.address,
        provider: wallet.provider,
        ...balance,
      }))
    );
    return {
      data: rows,
      total: rows.length,
    };
  },
};

registerModuleDataProvider(resourceName, xbitRelayHotWalletsDataProvider);
